import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import { ProtectedRoute } from "@/components/ProtectedRoute";
import { AppShell } from "@/components/AppShell";
import Landing from "@/pages/Landing";
import Login from "@/pages/Login";
import AcceptInvite from "@/pages/AcceptInvite";
import Dashboard from "@/pages/Dashboard";
import Patients from "@/pages/Patients";
import PatientDetail from "@/pages/PatientDetail";
import Calendar from "@/pages/Calendar";
import Invoices from "@/pages/Invoices";
import Announcements from "@/pages/Announcements";
import AIStudio from "@/pages/AIStudio";
import Recall from "@/pages/Recall";
import FormsAdmin from "@/pages/FormsAdmin";
import PublicForm from "@/pages/PublicForm";
import PublicFormsIndex from "@/pages/PublicFormsIndex";
import OwnerConsole from "@/pages/OwnerConsole";

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<Landing />} />
          <Route path="/login" element={<Login />} />
          <Route path="/invite/:token" element={<AcceptInvite />} />
          <Route path="/forms" element={<PublicFormsIndex />} />
          <Route path="/forms/:key" element={<PublicForm />} />
          <Route path="/intake" element={<PublicForm templateKey="intake" />} />
          <Route path="/medical-history" element={<PublicForm templateKey="medical_history" />} />
          <Route path="/consent" element={<PublicForm templateKey="consent" />} />
          <Route path="/dental-history" element={<PublicForm templateKey="dental_history" />} />
          <Route
            path="/owner"
            element={
              <ProtectedRoute roles={["owner"]}>
                <OwnerConsole />
              </ProtectedRoute>
            }
          />
          <Route
            path="/app"
            element={
              <ProtectedRoute roles={["admin", "practitioner", "receptionist", "billing"]}>
                <AppShell />
              </ProtectedRoute>
            }
          >
            <Route index element={<Dashboard />} />
            <Route path="dashboard" element={<Dashboard />} />
            <Route path="calendar" element={<Calendar />} />
            <Route path="patients" element={<Patients />} />
            <Route path="patients/:id" element={<PatientDetail />} />
            <Route path="invoices" element={<Invoices />} />
            <Route path="recall" element={<Recall />} />
            <Route path="forms" element={<FormsAdmin />} />
            <Route path="announcements" element={<Announcements />} />
            <Route path="ai" element={<AIStudio />} />
          </Route>
        </Routes>
        <Toaster position="top-right" richColors />
      </BrowserRouter>
    </div>
  );
}

export default App;
